import React from 'react';

// Badge component for status indicators and labels
export const Badge = ({ 
  children,
  className = '', 
  variant = 'default',
  ...props 
}) => {
  const baseClasses = 'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2';
  
  const variants = {
    default: 'bg-emerald-600 text-white hover:bg-emerald-700',
    secondary: 'bg-slate-700 text-slate-300 hover:bg-slate-600',
    destructive: 'bg-red-600 text-white hover:bg-red-700',
    outline: 'border border-slate-600 bg-transparent text-slate-300 hover:bg-slate-700'
  };

  const variantClasses = variants[variant] || variants.default;

  return (
    <div
      className={`${baseClasses} ${variantClasses} ${className}`}
      {...props}
    >
      {children}
    </div>
  );
};
